var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getUniversityGroupId, getUniversityIdNew } from './Helpers';
export var PlausibleEventType;
(function (PlausibleEventType) {
    PlausibleEventType["Landed"] = "Landed on tap feed";
    PlausibleEventType["OpenSingUp"] = "Open sign-up form";
    PlausibleEventType["CompletedRegistration"] = "Completed registration";
    PlausibleEventType["CompletedFirstStep"] = "Sign-up first step completed";
    PlausibleEventType["CommunityLanded"] = "Landed on Community";
    PlausibleEventType["CommunitySignUpFirstStepEmail"] = "Community Sign-up email first step";
    PlausibleEventType["CommunitySignUpFirstStepGoogle"] = "Community Sign-up google first step";
    PlausibleEventType["CommunitySignInFirstStepComplete"] = "Community Sign-in first step completed";
    PlausibleEventType["CommunitySignUpFirstStepComplete"] = "Community Sign-up first step completed";
    PlausibleEventType["CommunitySignInComplete"] = "Community Sign-in completed";
    PlausibleEventType["CommunitySignUpComplete"] = "Community Sign-up completed";
})(PlausibleEventType || (PlausibleEventType = {}));
export var plausibleEventHandler = function (event, eventProps) {
    var _a;
    if (eventProps === void 0) { eventProps = {}; }
    var universityId = getUniversityIdNew();
    var groupId = getUniversityGroupId();
    var eventPropsObj = __assign({}, eventProps);
    if (universityId) {
        eventPropsObj.university_id = universityId;
    }
    if (groupId) {
        eventPropsObj.group_id = groupId;
    }
    if (typeof window !== 'undefined') {
        (_a = window.plausible) === null || _a === void 0 ? void 0 : _a.call(window, event, { props: eventPropsObj });
    }
};
